import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Footer.css';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [activeTab, setActiveTab] = useState('sales');
  return (
    <footer className='footer'>
      <div className="container">
        <div className="footer-widget">
          <div className="row">
            <div className="col-lg-6 col-md-8 order-1">
              <div className="widget site-info-widget">
                <div className="footer-logo">
                  <img
                    src="https://tripta.in/frontend/img/assets/Tripta%20white.png"
                    alt="Tripta"
                    
                  />
                </div>
                <nav style={{ marginTop: '20px' , marginBottom:'20px'}}>
                    <div className="nav-tab-switch" id="nav-tab-switch">
                    <button
                        className={`nav-tab-link ${activeTab === 'sales' ? 'active' : ''}`}
                        onClick={() => setActiveTab('sales')}
                    >
                        Sales
                    </button>
                    <button
                        className={`nav-tab-link ${activeTab === 'support' ? 'active' : ''}`}
                        onClick={() => setActiveTab('support')}
                    >
                        Support
                    </button>
                    </div>
                </nav>

                {/* Tab Content */}
                <div className="tab-content" style={{ margin: '-15px 0' }}>
                    {/* Sales Tab Content */}
                    {activeTab === 'sales' && (
                    <div className="tab-pane fade show active">
                        <ul className="contact-infos mt-30">
                        <li className="mt-2">
                            <a href="tel:+919723102310">
                            <i class="fas fa-phone"></i>{' '}
                            +91 97 2310 2310
                            </a>
                        </li>
                        <li className="mt-2">
                            <a href="mailto:sales@tripta.in">
                            <i className="color-red fas fa-envelope"></i> sales@tripta.in
                            </a>
                        </li>
                        </ul>
                    </div>
                    )}

                    {/* Support Tab Content */}
                    {activeTab === 'support' && (
                    <div className="tab-pane fade show active">
                        <ul className="contact-infos mt-30">
                        <li className="mt-2">
                            <a href="tel:+912612307700">
                            <i
                                className="color-red fas fa-phone"
                            ></i>{' '}
                            +91 261 230 7700
                            </a>
                        </li>
                        <li className="mt-2">
                            <a href="mailto:support@tripta.in">
                            <i className="color-red fas fa-envelope"></i> support@tripta.in
                            </a>
                        </li>
                        <li className="mt-2">
                            <a className='office-timing-hover'>
                                <i className="color-red far fa-clock"></i> Mon - Fri: 10:15 AM - 7:00 PM
                                <br />
                                Saturday: 10:15 AM - 5:00 PM
                            </a>
                        </li>
                        </ul>
                    </div>
                    )}
                </div>
                <p className='follow-us-para'>
                  <a href="/social-media-handles">Follow us:</a>
                </p>
                <ul className="social-links">
                  <li>
                    <a className="footer-icon" href="https://www.linkedin.com/company/tripta-innovations-pvt-ltd" target="_blank" rel="noreferrer">
                      <img src="https://tripta.in/frontend/images/linkedin-icon.png" alt="LinkedIn" />
                    </a>
                  </li>
                  <li>
                    <a className="footer-icon" href="https://www.instagram.com/triptainnovations/" target="_blank" rel="noreferrer">
                      <img src="https://tripta.in/frontend/images/instagram-icon.png" alt="Instagram" />
                    </a>
                  </li>
                  <li>
                    <a className="footer-icon" href="https://www.youtube.com/channel/UCu1nUrSQf7RiaJ_mMsdU1pw" target="_blank" rel="noreferrer">
                      <img src="https://tripta.in/frontend/images/youtube-icon.png" alt="YouTube" />
                    </a>
                  </li>
                  <li>
                    <a className="footer-icon" href="https://www.facebook.com/TriptaIndia/" target="_blank" rel="noreferrer">
                      <img src="https://tripta.in/frontend/images/facebook-icon.png" alt="Facebook" />
                    </a>
                  </li>
                  <li>
                    <a className="footer-icon" href="https://g.page/r/CXjAgcgkLGvbEAg/review" target="_blank" rel="noreferrer">
                      <img src="https://tripta.in/frontend/images/google-icon-1.png" alt="YouTube" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-7 order-2">
              <div className="widget nav-widget">
                <h4 className="widget-title">Company</h4>
                <ul>
                  <li>
                    <a href="https://tripta.in/about">About Us</a>
                  </li>
                  <li>
                    <a href="https://tripta.in/accounting-software">Our Products</a>
                  </li>
                  <li>
                    <a href="https://tripta.in/about#Award">Awards</a>
                  </li>
                  <li>
                    <a href="https://tripta.in/career">Careers</a>
                  </li>
                  <li>
                    <a href="https://search.google.com/local/reviews?placeid=ChIJzTcNjkNO4DsReMCByCQsa9s">Reviews</a>
                  </li>
                  <li>
                    <a href="https://tripta.in/contact_us">Contact Us</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-sm-7 order-2">
              <div className="widget nav-widget">
                <h4 className="widget-title">Quick Links</h4>
                <ul>
                  <li>
                    <a href="https://tripta.in/Manual/Radix%20for%20Website/GettingHelp.html">Radix Manual</a>
                  </li>
                  <li>
                    <a href="https://tripta.in/radix-faq">Radix FAQ</a>
                  </li>
                  <li>
                    <a href="https://tripta.in/Manual/RELY%20for%20Website/GettingStarted.html">Rely Manual</a>
                  </li>
                  <li>
                    <a href="https://tripta.in/rely-faq">Rely FAQ</a>
                  </li>
                  <li>
                    <a href="https://tripta.in/download/TeamViewerQS_en-idcup63hyv.exe">Download Remote Support</a>
                  </li>
                  <li>
                    <a href="https://payment.tripta.in/">Pay Now</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-copyright">
        <a
          className="back-to-top"
          onClick={(e) => {
            e.preventDefault(); // Prevent default anchor behavior
            const headerElement = document.getElementById('myHeader'); // Select the element by its ID
            if (headerElement) {
              headerElement.scrollIntoView({
                behavior: 'smooth', // Adds a smooth scroll effect
                block: 'start', // Aligns to the top of the viewport
              });
            }
          }}
        >
          <i className="fa fa-angle-up"></i>
        </a>
          <p className="copyright-text">
            <span>
              Copyright © {currentYear} Tripta Innovations PVT LTD. All Rights Reserved.
            </span>
          </p>
        </div>
        <img src="https://tripta.in/frontend/img/lines/01.png" alt="line-shape" class="line-one" />
        <img src="https://tripta.in/frontend/img/lines/02.png" alt="line-shape" class="line-two"/>
      </div>
    </footer>
  );
};

export default Footer;
